
import { defineComponent } from "vue";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";
import DxButton from "devextreme-vue/button";
import { DxSelectBox } from "devextreme-vue";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueSelectControl,
    DxButton,
    DxSelectBox,
  },
  methods: {
    async onFilterChange(){
      const { data } = await api.get(
        `/ContainerReport/GetFilterValues`,
        {
          params: {
            planId: this.model.planId,
            orderId: this.selectedOptions.orderId,
            nomenclatureId: this.selectedOptions.nomenclatureId,
            nomenclatureName: this.selectedOptions.nomenclatureName,
            packageLength: this.selectedOptions.packageLength,
            packageCut: this.selectedOptions.packageCut,
          },
        }
      );
      this.options = (data as any);
    },
    async onPlanChange() {
      if (this.model.planId) {        
        this.showOptions = true;
      }
      else {
        this.options = {};
        this.showOptions = false;
      }
      this.selectedOptions = {};
      await this.onFilterChange();
    },
    onButtonClick() {
      if (this.loading)
        this.onStop();
      else this.onReport();
    },
    onReport() {
      this.$emit("onReport", this.model.planId, this.selectedOptions);
    },
    onStop() {
      this.$emit("onStop");
    },
  },
  props: { loading: { required: false } },
  data() {
    return {
      model: {},
      showOptions: false,
      options: {
        order: null,
        nomenclatureLine: null,
        nomenclature: null,
        packageLength: null,
        packageCut: null,
      },
      selectedOptions: {
        orderId: null,
        nomenclatureId: null,
        nomenclatureName: null,
        packageLength: null,
        packageCut: null,
      },
      nomenclatureList: null,
      orderList: null,
    };
  },
});
